var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { clearPayload } from 'ziphy-web-shared/basic/api/myack/api.helpers';
import { BaseService } from '../../baseService';
export class Resources extends BaseService {
    constructor(props) {
        super(props);
        this.medicationStatement = new MedicationStatementService(props);
        this.medicationRequest = new MedicationRequestService(props);
        this.allergy = new AllergyService(props);
        this.condition = new ConditionService(props);
        this.procedureSurgicalHistory = new ProcedureSurgicalHistoryService(props);
        this.procedureBillable = new ProcedureBillableService(props);
        this.immunization = new ImmunizationService(props);
        this.patient = new PatientService(props);
        this.patientContact = new PatientContactService(props);
        this.patientEmergencyContact = new PatientEmergencyContactService(props);
        this.taskReferralSpecialist = new TaskReferralSpecialistService(props);
        this.taskReferralService = new TaskReferralServiceService(props);
        this.taskRequestAppointment = new TaskRequestAppointmentService(props);
        this.taskRequestAppointmentPcp = new TaskRequestAppointmentPcpService(props);
        this.taskOrderLab = new TaskOrderLabService(props);
        this.taskOrderImaging = new TaskOrderImagingService(props);
    }
    search(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            params = clearPayload(params);
            res = yield this.api.fetchLoggedV3('notes.search', params, options);
            return res;
        });
    }
}
const CREATE_ENDPOINT = 'notes.resource.create';
const GET_ENDPOINT = 'notes.resource.get';
const UPDATE_ENDPOINT = 'notes.resource.update';
/**
 * MedicationStatement
 */
class MedicationStatementService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'medication.statement') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * MedicationRequest
 */
class MedicationRequestService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'medication.request') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * Allergy
 */
class AllergyService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'allergy') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * Condition
 */
class ConditionService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'condition') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * Procedure
 */
class ProcedureSurgicalHistoryService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'procedure.surgical_history') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
class ProcedureBillableService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'procedure.billable') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * Immunization
 */
class ImmunizationService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'immunization') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * Patient
 */
class PatientService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'patient.demographics.basic') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * PatientContact
 */
class PatientContactService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'patient.contact') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * PatientEmergencyContact
 */
class PatientEmergencyContactService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'patient.emergency_contact') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * TaskReferralSpecialist
 */
class TaskReferralSpecialistService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'referral.specialist') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * TaskReferralService
 */
class TaskReferralServiceService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'referral.service') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * TaskRequestAppointment
 */
class TaskRequestAppointmentService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'request.visit.ziphy') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * TaskRequestAppointmentPcp
 */
class TaskRequestAppointmentPcpService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'request.visit.pcp') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * TaskOrderLab
 */
class TaskOrderLabService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'order.lab') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
/**
 * TaskOrderImaging
 */
class TaskOrderImagingService extends BaseService {
    constructor(props) {
        super(props);
    }
    prepareParams(params, elementName = 'order.imaging') {
        if ('data' in params)
            params = Object.assign(Object.assign({}, params), { data: clearPayload(params.data) });
        return clearPayload(Object.assign({ elementName }, params));
    }
    create(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(CREATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(GET_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
    save(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3(UPDATE_ENDPOINT, this.prepareParams(params), options);
            return res;
        });
    }
}
